import React, { Component } from 'react';
import PropTypes from 'prop-types';

const version = process.env.REACT_APP_VERSION;

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {

    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    var date= new Date();
    return (
        <React.Fragment>
          <span>v{version} &copy; {date.getFullYear()} Simgulary, LLC. All rights reserved </span>
          <span className="ml-auto"></span>
        </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultFooter.js